import { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import QuickReferenceModal from './QuickReferenceModal';

export default function ChatInputBar({ onAsk, onClear, disabled }) {
    const [query, setQuery] = useState('');
    const [isQuickRefOpen, setIsQuickRefOpen] = useState(false);

    const handleAskClick = () => {
        if (!query.trim()) return;
        onAsk(query);
        setQuery('');
    };

    const responsibleAiLink = "https://docs.google.com/document/d/1VCi-6Pklx-50wcamcLxKmlHuPspUDARpBE_XJ1HBDvk/edit?tab=t.0";

    return (
        <>
            {/* Top row: input + buttons */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Ask a question..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && !disabled && handleAskClick()}
                    disabled={disabled}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Button
                        variant="contained"
                        onClick={handleAskClick}
                        disabled={disabled || !query.trim()}
                        sx={{
                            bgcolor: '#006400', // Dark green
                            '&:hover': { bgcolor: '#004d00' },
                            color: 'white',
                            fontWeight: 'bold',
                            borderRadius: '20px',
                            width: '70px'
                        }}
                    >
                        ASK
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onClear}
                        disabled={disabled}
                        sx={{
                            bgcolor: '#8B0000', // Dark red
                            '&:hover': { bgcolor: '#5a0000' },
                            color: 'white',
                            fontWeight: 'bold',
                            borderRadius: '20px',
                            width: '70px'
                        }}
                    >
                        ⏹
                    </Button>
                </Box>
            </Box>

            {/* Bottom row: info & action buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                <Typography variant="caption" sx={{ color: '#333' }}>
                    Need help on how to use RBS - Co-Pilot
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        bgcolor: '#006400',
                        '&:hover': { bgcolor: '#004d00' },
                        color: 'white',
                        textTransform: 'none',
                        borderRadius: '15px'
                    }}
                    onClick={() => setIsQuickRefOpen(true)}
                >
                    Quick Reference
                </Button>
                <Typography variant="caption" sx={{ color: '#333' }}>
                    Do not put PHI data in the chat
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        bgcolor: '#8B0000',
                        '&:hover': { bgcolor: '#5a0000' },
                        color: 'white',
                        textTransform: 'none',
                        borderRadius: '15px'
                    }}
                    onClick={() => window.open(responsibleAiLink, '_blank', 'noopener,noreferrer')}
                >
                    See Rules
                </Button>
            </Box>

            <QuickReferenceModal
                open={isQuickRefOpen}
                onClose={() => setIsQuickRefOpen(false)}
            />
        </>
    );
}
